import CustomerListViewModel from "../view/customerlistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedCustomers extends PagedElements<CustomerListViewModel> {
    constructor(init?: Partial<PagedCustomers>) { super(init); }
}